import { Table } from 'antd'
import type { ReactNode } from 'react'
import styled from 'styled-components'

const PayReportCustomCellWrapper = ({
  children,
  ...props
}: {
  children: ReactNode
}) => <PayReportCustomCell {...props}>{children}</PayReportCustomCell>

const PayReportCustomTableWrapper = ({
  children,
  ...props
}: {
  children: ReactNode
}) => (
  <PayReportCustomTable {...props}>{children}</PayReportCustomTable>
)

export const payReportTableComponents = {
  table: PayReportCustomTableWrapper,
  body: {
    cell: PayReportCustomCellWrapper
  }
}

const PayReportCustomTable = styled.table`
  background: ${({ theme }) => theme.color.background.tertiary};
`

const PayReportCustomCell = styled.td`
  box-sizing: border-box;
  height: 72px;
  padding: 16px 12px !important;
  vertical-align: middle;
  background-color: inherit !important;
`

export const StyledPayReportTable = styled(Table)`
  & .ant-table {
    min-width: max-content;
  }

  & .ant-table-thead > tr > th {
    white-space: nowrap;
  }

  & .ant-table-column-sorters {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  & .ant-table-column-sorter {
    margin-right: 4px;
    margin-left: 0;
  }

  & .ant-table-thead > tr > th.reconciliation-header-multiline {
    white-space: pre-line;
    vertical-align: bottom;
  }

  & .even-row {
    background-color: ${({ theme }) => theme.color.neutral.color11};
  }

  & .odd-row {
    background-color: ${({ theme }) => theme.color.neutral.color10};
  }

  & .ant-table-tbody > tr.ant-table-row-selected > td {
    background: inherit;
  }
` as typeof Table
